import React from 'react'
import { withRouter, Switch, Route, Redirect } from 'react-router-dom'
import gsap from 'gsap'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { connect } from 'react-redux'

import PrivateRoute from 'components/PrivateRoute/PrivateRoute'
import LottiePreloader from 'components/Lottie/LottiePreloader'
import PainRatingPage from 'pages/PainRatingPage'
import IndicationSelectPage from 'pages/IndicationSelectPage'
import SongSelectPage from 'pages/SongSelectPage'
import AuthPage from 'pages/AuthPage'
import MyAccount from 'pages/MyAccount'
import MyAccount2 from 'pages/MyAccount2'
import MyAccount3 from 'pages/MyAccount3'
import ContactForm from 'pages/ContactForm'
import SignupPage from 'pages/SignupPage'
import PlayerPage from 'pages/PlayerPage'
import MobileManage from 'pages/MobileManage'
import RequestAccessPage from 'pages/RequestAccessPage'
import Spinner from 'components/ui/Spinner/Spinner'
import WelcomePage from 'pages/WelcomePage'
import WelcomeDoctorPage from 'pages/WelcomeDoctorPage'
import SubscriptionPage from 'pages/SubscriptionPage'
import DoctorRegisterPage from 'pages/DoctorRegisterPage'
import LicensePage from 'pages/LicensePage'
import MainPage from 'pages/MainPage'
import UpdateSongMobilePage from 'pages/UpdateSongMobilePage'
import history from 'utils/appHistory'
import { t } from 'translation'

import { sessionApi } from 'api'

import Amplify, { Hub } from 'aws-amplify'

import {
  authFail,
  continuouslyCheckForAlarm,
  fetchAllMusic,
  initializeHistory,
  initialAutoAuth,
  initializeAlarms,
  initializePlaylist,
  intializeDownloadedSongs,
  setAuthSocialMessage,
  setIsOnlineState,
  downloadCompanyLogo,
  fetchAllLocalMusic,
} from 'store/actions'

import { getSessions, deleteSessions } from 'utils/sqlite'

const ENV = process.env.NODE_ENV
const logoBaseUrl =
  ENV === 'production'
    ? process.env.COMPANY_LOGO_URL_PRODUCTION
    : ENV === 'dev-remote'
    ? process.env.COMPANY_LOGO_URL_DEV_REMOTE
    : process.env.COMPANY_LOGO_URL_DEVELOPMENT

class Main extends React.Component {
  constructor() {
    super()

    this.state = {
      prevLocation: null,
      initialLoading: true,
      // isLottieAnimComplete: true,
    }

    // this.setLottieAnimationComplete = this.setLottieAnimationComplete.bind(this)
  }

  // setLottieAnimationComplete() {
  //   this.setState({ isLottieAnimComplete: true })
  // }

  componentDidMount() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('offline', () => this.props.setIsOnlineState(false))
    window.addEventListener('online', () => this.props.setIsOnlineState(true))

    initializeAuth(this.props.setAuthSocialMessage, this.props.authFail)

    const autoLogIn = async () => {
      const loggedIn = await this.props.initialAutoAuth()

      if (loggedIn) {
        await this.initialize()

        if (this.props.isOnline && window?.cordova) this.syncSessions()
        // if (!window.cordova || !this.props.downloadedSongs.length)
        //   alert(t('auth.PLEASE_CONNECT_TO_INTERNET'))
      }

      this.setState({ initialLoading: false })

      if (loggedIn && history.location.pathname === '/auth') {
        const showWelcomeVideo =
          this.props.attributes?.permissions?.features?.alwaysOnWelcomeVideo

        const redirectPath =
          showWelcomeVideo && !this.props.isDoctor
            ? `/welcome`
            : this.props.isDoctor
            ? `/welcome-doctor`
            : '/indication-select'

        history.push(redirectPath)
      }
    }

    // Try to log in if token exists and if did not just merge social accounts with cognito
    if (!this.props.socialMessage) autoLogIn()

    setTimeout(() => {
      document.body.classList.remove('login_mod')
    }, 1000)
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isAuthenticated && this.props.isAuthenticated) {
      this.initialize()
    }

    if (
      !prevProps.isOnline &&
      this.props.isOnline &&
      this.props.isAuthenticated &&
      window?.cordova
    )
      this.syncSessions()
  }

  syncSessions = async () => {
    console.log('Starting sync sessions on the edge...')
    let sessions
    do {
      sessions = await getSessions(this.props.sessionDb, this.props.sessionDbTable)

      if (sessions.length === 0) break

      const { result, error } = await sessionApi.sendMultipleSession(sessions)

      const ids = sessions.map((session) => session.id)
      const idsFormatted = ids.join()
      await deleteSessions(this.props.sessionDb, this.props.sessionDbTable, idsFormatted)

      await new Promise((res) => setTimeout(res, 500))
    } while (this.props.isOnline && sessions.length > 0)
    console.log('Stopping sync session data on the edge.')
  }

  initialize = async () => {
    if (window.cordova) {
      await this.props.intializeDownloadedSongs()
      await this.props.fetchAllLocalMusic()
      //this.props.fetchAllMusic()
      if (
        !localStorage.getItem('companyLogoDownloaded') &&
        this.props.attributes?.companyLogo &&
        this.props.isOnline &&
        this.props.isAuthenticated
      )
        await this.props.downloadCompanyLogo(
          `${logoBaseUrl}/${decodeURI(this.props.attributes?.companyLogo)}`,
          decodeURI(this.props.attributes?.companyLogo)
        )
    } else {
      this.props.fetchAllMusic()
    }

    this.props.initializeHistory()
    this.props.initializeAlarms()
    this.props.initializePlaylist()
    this.alarmCheckIntervalId = this.props.continuouslyCheckForAlarm()
  }

  handleResize = () => {
    const html = document.documentElement
    const windowHeight = window.innerHeight

    const vh = windowHeight * 0.01
    document.documentElement.style.setProperty('--vh', vh + 'px')

    if (windowHeight >= 1366) {
      html.classList.add('vert_2_mod')
      if (html.classList.contains('vert_mod')) {
        html.classList.remove('vert_mod')
      }
    } else if (windowHeight >= 1080) {
      if (html.classList.contains('vert_2_mod')) {
        html.classList.remove('vert_2_mod')
      }
    } else if (windowHeight <= 400) {
      const vh = windowHeight * 0.015
      document.documentElement.style.setProperty('--vh', vh + 'px')
      html.classList.add('vert_2_mod')

      if (html.classList.contains('vert_mod')) {
        html.classList.remove('vert_mod')
      }
    } else {
      if (html.classList.contains('vert_mod')) {
        html.classList.remove('vert_mod')
      }
      html.classList.add('vert_2_mod')
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('offline', () => this.props.setIsOnlineState(false))
    window.removeEventListener('online', () => this.props.setIsOnlineState(true))

    if (this.alarmCheckIntervalId) clearInterval(this.alarmCheckIntervalId)
  }

  handleOnEnterAnim = (node) => {
    const pathname = this.props.location.pathname
    if (this.state.prevLocation === pathname || node === undefined) return

    gsap.fromTo(
      node,
      1,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        onComplete: () =>
          this.setState({
            prevLocation: pathname,
          }),
      }
    )
  }

  handlePageAnim = (_, done) => done()

  addingClassOnAuthPage = () => {
    return history.location.pathname === '/login' ||
      history.location.pathname === '/signup'
      ? 'login_mod'
      : ''
  }

  render() {
    const isDoctor = this.props.isDoctor

    const showWelcomeVideo =
      this.props.attributes?.permissions?.features?.alwaysOnWelcomeVideo

    const isIos = window.cordova && window.device?.platform === 'iOS'
    const isAndroid = window.cordova && window.device?.platform === 'Android'

    return !this.state.initialLoading ? (
      <main className={`base ${this.addingClassOnAuthPage()}`}>
        <TransitionGroup>
          <CSSTransition
            key={this.props.location.key}
            addEndListener={this.handlePageAnim}
            onEnter={this.handleOnEnterAnim}
            appear
          >
            <div>
              <Switch location={this.props.location}>
                <Route exact path="/auth" render={(props) => <MainPage {...props} />} />
                <Route
                  exact
                  path="/request-access"
                  render={(props) => <RequestAccessPage {...props} />}
                />
                <Route exact path="/login" render={(props) => <AuthPage {...props} />} />
                <Route
                  exact
                  path="/license"
                  render={(props) => <LicensePage {...props} />}
                />
                {/* TODO: Enable routes when ready */}
                {!window?.cordova &&
                  this.props.isAuthenticated &&
                  this.props.attributes?.updatePayment && (
                    <PrivateRoute path="/" component={MyAccount3} />
                  )}
                {!window?.cordova &&
                  this.props.isAuthenticated &&
                  !this.props.attributes?.subscribed &&
                  !this.props.isPro && (
                    <PrivateRoute path="/" component={SubscriptionPage} />
                  )}
                {window?.cordova &&
                  this.props.isAuthenticated &&
                  this.props.attributes?.updatePayment && (
                    <PrivateRoute path="/" component={MobileManage} />
                  )}
                {window?.cordova &&
                  this.props.isAuthenticated &&
                  !this.props.attributes?.subscribed &&
                  !this.props.isPro && <PrivateRoute path="/" component={MobileManage} />}
                <PrivateRoute exact path="/my-account" component={MyAccount} />
                <PrivateRoute exact path="/my-account2" component={MyAccount2} />
                <PrivateRoute exact path="/my-account3" component={MyAccount3} />
                <Route
                  exact
                  path="/contact"
                  render={(props) => <ContactForm {...props} />}
                />
                <Route
                  exact
                  path="/register-doctor"
                  render={(props) => <DoctorRegisterPage {...props} language={'en'} />}
                />
                <Route
                  exact
                  path="/inscription-medecin"
                  render={(props) => <DoctorRegisterPage {...props} language={'fr'} />}
                />
                <Route
                  exact
                  path="/signup"
                  render={(props) => <SignupPage {...props} />}
                />
                {showWelcomeVideo && !isDoctor ? (
                  <PrivateRoute exact path="/welcome" component={WelcomePage} />
                ) : null}
                {isDoctor && (
                  <PrivateRoute
                    exact
                    path="/welcome-doctor"
                    component={WelcomeDoctorPage}
                  />
                )}
                <PrivateRoute
                  exact
                  path="/indication-select"
                  component={IndicationSelectPage}
                />
                <PrivateRoute exact path="/access" component={MobileManage} />
                <PrivateRoute exact path="/song-select" component={SongSelectPage} />
                <PrivateRoute exact path="/player" component={PlayerPage} />
                <PrivateRoute exact path="/pain-rating" component={PainRatingPage} />
                <PrivateRoute exact path="/subscription" component={SubscriptionPage} />
                {isAndroid && (
                  <PrivateRoute
                    exact
                    path="/update-songs-mobile"
                    component={UpdateSongMobilePage}
                  />
                )}
                <PrivateRoute path="/" component={WelcomePage} />
                <Route path="/" render={() => <Redirect to="/auth" />} />
              </Switch>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </main>
    ) : null
  }
}

const mapStateToProps = ({
  auth: {
    attributes,
    isDoctor,
    isPro,
    isAuthenticated,
    language,
    socialMessage,
    isOnline,
  },
  player: { sessionDb, sessionDbTable },
  download: { downloadedSongs },
}) => ({
  attributes,
  downloadedSongs,
  isAuthenticated,
  language,
  socialMessage,
  isDoctor,
  isPro,
  isOnline,
  sessionDb,
  sessionDbTable,
})

const willMapDispatchToProps = {
  authFail,
  continuouslyCheckForAlarm,
  fetchAllMusic,
  initialAutoAuth,
  initializeHistory,
  initializePlaylist,
  initializeAlarms,
  intializeDownloadedSongs,
  setAuthSocialMessage,
  setIsOnlineState,
  downloadCompanyLogo,
  fetchAllLocalMusic,
}

export default withRouter(connect(mapStateToProps, willMapDispatchToProps)(Main))

const initializeAuth = async (setAuthSocialMessage, authFail) => {
  Hub.listen('auth', ({ payload: { event, data } }) => {
    switch (event) {
      // case 'signIn':
      //   break
      // case 'signOut':
      //   break
      // case 'customOAuthState':
      //   break
      case 'cognitoHostedUI_failure':
        {
          if (data.message.startsWith('Already+found+an+entry+for+username+')) {
            return setAuthSocialMessage('ACCOUNTS_UPDATED_FOR_SOCIAL_SIGN_IN')
          }

          let message = 'AN_ERROR_OCCURED_PLEASE_TRY_LATER'
          if (
            data.message.startsWith('PreSignUp+failed+with+error+User+does+not+exist')
          ) {
            message = 'PLEASE_REGISTER_BEFORE_SOCIAL_SIGN_IN'
          } else if (
            data.message ===
            'PreSignUp+failed+with+error+User+status+must+be+CONFIRMED+to+sign+in+with+a+social+identity.+Current+status%3A+FORCE_CHANGE_PASSWORD.+'
          ) {
            message = 'PLEASE_SET_A_PRIVATE_PASSWORD_BEFORE_SOCIAL_SIGN_IN'
          }

          return authFail(t(`auth.${message}`))
        }
        break
    }
  })

  const ENV = process.env.NODE_ENV

  const region =
    ENV === 'production'
      ? process.env.AUTH_REGION_PRODUCTION
      : ENV === 'dev-remote'
      ? process.env.AUTH_REGION_DEV_REMOTE
      : process.env.AUTH_REGION_DEVELOPMENT

  const userPoolId =
    ENV === 'production'
      ? process.env.AUTH_USER_POOL_ID_PRODUCTION
      : ENV === 'dev-remote'
      ? process.env.AUTH_USER_POOL_ID_DEV_REMOTE
      : process.env.AUTH_USER_POOL_ID_DEVELOPMENT

  const userPoolWebClientId =
    ENV === 'production'
      ? process.env.AUTH_WEB_CLIENT_ID_PRODUCTION
      : ENV === 'dev-remote'
      ? process.env.AUTH_WEB_CLIENT_ID_DEV_REMOTE
      : process.env.AUTH_WEB_CLIENT_ID_DEVELOPMENT

  const domain =
    ENV === 'production'
      ? process.env.AUTH_DOMAIN_PRODUCTION
      : ENV === 'dev-remote'
      ? process.env.AUTH_DOMAIN_DEV_REMOTE
      : process.env.AUTH_DOMAIN_DEVELOPMENT

  const redirectSignIn =
    ENV === 'production'
      ? process.env.AUTH_REDIRECT_SIGN_IN_PRODUCTION
      : ENV === 'dev-remote'
      ? process.env.AUTH_REDIRECT_SIGN_IN_DEV_REMOTE
      : process.env.AUTH_REDIRECT_SIGN_IN_DEVELOPMENT

  const redirectSignOut =
    ENV === 'production'
      ? process.env.AUTH_REDIRECT_SIGN_OUT_PRODUCTION
      : ENV === 'dev-remote'
      ? process.env.AUTH_REDIRECT_SIGN_OUT_DEV_REMOTE
      : process.env.AUTH_REDIRECT_SIGN_OUT_DEVELOPMENT

  Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region,
      userPoolId,
      userPoolWebClientId,
      oauth: {
        domain,
        scope: process.env.AUTH_SCOPE.split(','),
        redirectSignIn,
        redirectSignOut,
        responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      },
    },
  })
}
